import React from "react";
import { List } from "react-window";
import DeleteIcon from "../../../assets/icons/delete-icon";

const COLUMNS = [
  { key: "item_code", label: "Item Code", width: "120px" },
  { key: "item_name", label: "Item Name", width: "minmax(220px,1fr)" },
  { key: "item_available_qty", label: "Item Available Qty", width: "160px" },
  { key: "item_qty", label: "Item Qty", width: "110px" },
  { key: "allocated_qty", label: "Allocated Qty", width: "140px" },
  { key: "no_of_parties", label: "No. of Parties", width: "130px" },
  { key: "item_total", label: "Item Total", width: "130px" },
  { key: "actions", label: "", width: "10rem" },
];

const GRID_TEMPLATE_COLUMNS = COLUMNS.map((column) => column.width).join(" ");

const ROW_HEIGHT = 50;

const rowClass =
  "grid items-center bg-[var(--create-table-row-bg)] border-b border-[var(--create-table-border)]";

const cellClass =
  "px-[8px] text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] text-[var(--create-table-row-fg-color)] whitespace-nowrap overflow-hidden text-ellipsis";

const headerCellClass =
  "px-[8px] whitespace-nowrap text-left text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]";

const Row = ({ index, style, rows, onAllocate, onDelete }) => {
  const row = rows[index];
  return (
    <div
      role="row"
      style={{ ...style, gridTemplateColumns: GRID_TEMPLATE_COLUMNS }}
      className={rowClass}
    >
      <div role="cell" className={cellClass}>
        {row.item_code}
      </div>
      <div role="cell" className={cellClass}>
        {row.item_name}
      </div>
      <div role="cell" className={cellClass}>
        {row.item_available_qty}
      </div>
      <div role="cell" className={cellClass}>
        {row.item_qty}
      </div>
      <div role="cell" className={cellClass}>
        {row.allocated_qty || 0} / {row.required_qty || 0}
      </div>
      <div role="cell" className={cellClass}>
        {row.no_of_parties}
      </div>
      <div role="cell" className={cellClass}>
        ₹
        {Number(row.item_total).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </div>
      <div role="cell" className="px-[8px]">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => onAllocate(index)}
            className="bg-[var(--primary)] text-white text-xs font-semibold px-4 py-1.5 rounded-md hover:opacity-90"
          >
            Allocate
          </button>
          <DeleteIcon onClickFn={() => onDelete(index)} />
        </div>
      </div>
    </div>
  );
};

const BulkReturnTable = ({ rows = [], onAllocate = () => {}, onDelete = () => {} }) => {
  return (
    <div role="table" className="table-container mt-2 h-full flex flex-col">
      <div
        role="row"
        style={{ gridTemplateColumns: GRID_TEMPLATE_COLUMNS }}
        className="grid items-center flex-none h-[50px] bg-[var(--create-table-header-bg)]"
      >
        {COLUMNS.map((column) => (
          <div key={column.key} role="columnheader" className={headerCellClass}>
            {column.label}
          </div>
        ))}
      </div>
      <div className="flex-1 min-h-0">
        <List
          rowComponent={Row}
          rowCount={rows.length}
          rowHeight={ROW_HEIGHT}
          rowProps={{ rows, onAllocate, onDelete }}
          style={{ height: "100%", width: "100%" }}
        />
      </div>
    </div>
  );
};

export default BulkReturnTable;
